import * as Yup from 'yup';

const schema = Yup.object({
  search: Yup.string()
    .nullable()
    .label('Nimi tai sähköpostiosoite')
});

export default schema;
export type Schema = ReturnType<typeof schema.cast>;
